export const downloadReportHeading = 'Download Report';
export const downloadReportDescription =
    'Each tile downloaded as CSV, Excel or PNG will export as a separate file in a zip folder. Each tile downloaded as PPT will export as a separate slide in one PPT deck.';
export const downloadOptions = ['CSV', 'Excel (.xlsx)'] as const;
export const disabledDownloadOptions = ['Powerpoint (.ppt)', 'Image (PNG)'];
export const disabledOptionMessage = 'Coming soon!';
export const downloadReportFooterNote = 'Note: The Data Context will be included in every downloaded file.';
export const mandatoryTiles = ['Terms and Conditions'];
